// extracted by mini-css-extract-plugin
export default {"indicators":"indicators---un6V0"};